import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { CircularProgress } from '@material-ui/core';


const styles = {
    background: {
        backgroundColor: grey[100],
        width: '100%',
        height: '100vh'
    },
    center: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    }

};

class LoadingSession extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.background}>
                <CircularProgress className={classes.center} />
            </div>
        );
    }
}

export default withStyles(styles)(LoadingSession);